export default __webpack_public_path__ + "static/media/home-left-side.ee2dc436.svg";